<div #scroller class="betslip-edit-state__scroller">
    <ng-content />
    @if (betslipUpsellConfig.modulePosition === 'top') {
        <bs-upsell-container />
    }

    @for (type of linearBetslipTypesOrder; track type) {
        @switch (type) {
            @case (betslipTypes.Combo) {
                @if (isComboModuleActive) {
                    <bs-combo-bet-linear
                        [oddsDisplayFormat]="oddsDisplayFormat"
                        [removeButtonPosition]="removeButtonPosition.None"
                        [removeButtonStyle]="removeButtonStyle.Ex" />
                }
            }
            @case (betslipTypes.Single) {
                @if (isActive(betslipTypes.Single)) {
                    <bs-single-bet-linear
                        [oddsDisplayFormat]="oddsDisplayFormat"
                        [removeButtonPosition]="removeButtonPosition.Left"
                        [removeButtonStyle]="removeButtonStyle.Ex" />
                }
            }
            @case (betslipTypes.System) {
                @if (isActive(betslipTypes.System)) {
                    <bs-system-bet-linear
                        [oddsDisplayFormat]="oddsDisplayFormat"
                        [removeButtonPosition]="removeButtonPosition.None"
                        [removeButtonStyle]="removeButtonStyle.Ex" />
                }
            }
            @case (betslipTypes.Teaser) {
                @if (isActive(betslipTypes.Teaser)) {
                    <bs-teaser-bet-linear [oddsDisplayFormat]="oddsDisplayFormat" />
                }
            }
            @case (betslipTypes.BetBuilder) {
                @if (isBetBuilderModuleActive) {
                    <bs-linear-bet-builder [oddsDisplayFormat]="oddsDisplayFormat" [removeButtonStyle]="removeButtonStyle.Ex" />
                }
            }
        }
    }

    @if (betslipUpsellConfig.modulePosition === 'bottom') {
        <bs-upsell-container />
    }

    <bs-digital-picks-linear-toolbar />
</div>
